module.exports = __webpack_public_path__ + "static/img/08.6a1e04cd.png";